import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenStorageService } from './token-storage.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import { jwtDecode, JwtPayload } from 'jwt-decode';

@Injectable()

export class AuthInterceptor implements HttpInterceptor {

    constructor(private tokenStorage: TokenStorageService, private router: Router, private ts: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.tokenStorage.getLoginToken();
        const customerToken = this.tokenStorage.getCompanyToken();

        if (customerToken && customerToken !== null && customerToken !== undefined) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${customerToken}`
                }
            });
        }else{
           request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });  
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                    // Token expired or unauthorized
                    // this.ts.warning('Unauthorized!');

                    this.tokenStorage.signOut(); // Optional: clear storage
                    this.router.navigate(['/signin']);

                } else if (error.status === 404) {
                    this.ts.warning('API URL doest not match');
                } else if (error.status === 400) {
                    this.ts.warning('Validation Error');
                } else if (error.status === 500) {
                    this.ts.warning('Internal Server Error');
                } else {
                    // this.ts.warning('Something went wrong');
                }
                return throwError(() => error);
            })
        );

    }

}